import React from 'react';
import Icon from '../../../components/AppIcon';

const PMMetricsCards = ({ metrics, loading }) => {
  const cards = [
    {
      title: 'Assigned Projects',
      value: loading ? '—' : metrics?.projectCount ?? 0,
      icon: 'Briefcase',
      color: 'text-blue-600',
      bg: 'bg-blue-50',
      border: 'border-blue-200',
      trend: null,
    },
    {
      title: 'Portfolio Value',
      value: loading ? '—' : `$${((metrics?.totalValue ?? 0) / 1000)?.toFixed(0)}K`,
      icon: 'DollarSign',
      color: 'text-emerald-600',
      bg: 'bg-emerald-50',
      border: 'border-emerald-200',
      trend: null,
    },
    {
      title: 'On-Time Delivery',
      value: loading ? '—' : `${metrics?.onTimePercent ?? 0}%`,
      icon: 'CheckCircle',
      color: metrics?.onTimePercent >= 80 ? 'text-green-600' : 'text-amber-600',
      bg: metrics?.onTimePercent >= 80 ? 'bg-green-50' : 'bg-amber-50',
      border: metrics?.onTimePercent >= 80 ? 'border-green-200' : 'border-amber-200',
      progress: metrics?.onTimePercent ?? 0,
    },
    {
      title: 'Budget Variance',
      value: loading ? '—' : `${metrics?.budgetVariance >= 0 ? '+' : ''}${metrics?.budgetVariance ?? 0}%`,
      icon: metrics?.budgetVariance >= 0 ? 'TrendingUp' : 'TrendingDown',
      color: metrics?.budgetVariance >= 0 ? 'text-green-600' : 'text-red-600',
      bg: metrics?.budgetVariance >= 0 ? 'bg-green-50' : 'bg-red-50',
      border: metrics?.budgetVariance >= 0 ? 'border-green-200' : 'border-red-200',
      trend: metrics?.budgetVariance >= 0 ? 'under' : 'over',
    },
  ];

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
      {cards?.map((card, idx) => (
        <div key={idx} className={`bg-white rounded-lg border ${card?.border} p-5 shadow-sm`}>
          <div className="flex items-center justify-between mb-3">
            <span className="text-sm font-medium text-gray-500">{card?.title}</span>
            <div className={`${card?.bg} p-2 rounded-lg`}>
              <Icon name={card?.icon} size={18} className={card?.color} />
            </div>
          </div>
          <div className={`text-2xl font-bold ${card?.color} mb-2`}>{card?.value}</div>
          {card?.progress !== undefined && (
            <div className="mt-2">
              <div className="w-full bg-gray-200 rounded-full h-1.5">
                <div
                  className={`h-1.5 rounded-full ${card?.progress >= 80 ? 'bg-green-500' : 'bg-amber-500'}`}
                  style={{ width: `${Math.min(card?.progress, 100)}%` }}
                />
              </div>
            </div>
          )}
          {card?.trend && (
            <p className="text-xs text-gray-400 mt-1">
              {card?.trend === 'under' ? 'Under budget' : 'Over budget'}
            </p>
          )}
        </div>
      ))}
    </div>
  );
};

export default PMMetricsCards;
